import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type GetSaveDefaultViewResponce } from '../services/getSaveDefaultViewService'

export interface GetDefaultWidgetDataState {
  isLoading: boolean
  loadingError: string | undefined
  DefaultWidgetData: GetSaveDefaultViewResponce[] | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: GetDefaultWidgetDataState = {
  isLoading: true,
  loadingError: undefined,
  DefaultWidgetData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const GetSaveDefaultWidgetDataState = createSlice({
  name: 'SaveDefaultWidgetData',
  initialState,
  reducers: {
    GetSaveDefaultWidgeLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        DefaultWidgetData: undefined,
        httpStatus: 0
      }
    },
    GetSaveDefaultWidgeUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        DefaultWidgetData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    GetSaveDefaultWidgeErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        DefaultWidgetData: undefined
      }
    }
  }
})

// Actions to export
export const {
  GetSaveDefaultWidgeLoadingAction,
  GetSaveDefaultWidgeUpdateAction,
  GetSaveDefaultWidgeErrorAction
} = GetSaveDefaultWidgetDataState.actions

export default GetSaveDefaultWidgetDataState.reducer
